import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-10 pb-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-196">
      {/* Brand */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-8" data-id="element-197">
        <span className="text-gold-400 font-bold tracking-[0.2em] uppercase text-base md:text-lg flex items-center justify-center gap-2" data-id="element-198">
          🐾 MUNDORECURSOS™
        </span>
      </motion.div>

      {/* Headline */}
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="text-3xl md:text-5xl font-bold text-white mb-6 leading-[1.15] tracking-tight" data-id="element-199">
        Domá el caos: Lográ un perro
        <br data-id="element-200" />
        <span className="text-gold-400" data-id="element-201">tranquilo desde hoy.</span>
      </motion.h1>

      {/* Product image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="relative w-full max-w-xs sm:max-w-sm md:max-w-md mx-auto mb-8" data-id="element-202">
        <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full" data-id="element-203"></div>
        <img src="https://cdn.magicpatterns.com/uploads/cA3xKv9M82YN4PWrqTA4WW/Gemini_Generated_Image_b0srjcb0srjcb0sr.png" alt="Guía del Perro Tranquilo - MegaPack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-204" />
      </motion.div>

      {/* Quote */}
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.3
    }} className="text-lg md:text-xl text-gold-400 italic font-medium max-w-2xl mx-auto mb-4 leading-relaxed" data-id="element-205">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin volver a casa con
        miedo de lo que vas a encontrar."
      </motion.p>

      {/* Description */}
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.35
    }} className="text-base md:text-lg text-white max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-206">
        Tu proceso completo de 21 días con tu perro — listo para aplicar desde
        hoy.
      </motion.p>

      {/* Inline badges */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 mb-8 text-sm md:text-base text-blue-50/90" data-id="element-207">
        <span className="flex items-center gap-1.5" data-id="element-208">📄 PDF</span>
        <span className="text-gold-500/40" data-id="element-209">·</span>
        <span className="flex items-center gap-1.5" data-id="element-210">⚡ Acceso Inmediato</span>
        <span className="text-gold-500/40" data-id="element-211">·</span>
        <span className="flex items-center gap-1.5" data-id="element-212">🌎 Habla Hispana</span>
        <span className="text-gold-500/40" data-id="element-213">·</span>
        <span className="flex items-center gap-1.5" data-id="element-214">🐾 Todos los perros</span>
      </motion.div>

      {/* CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.5
    }} className="w-full max-w-xl mx-auto" data-id="element-215">
        <a href="#pricing" className="block w-full py-5 px-6 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-bold text-lg md:text-xl rounded-2xl shadow-[0_0_30px_rgba(212,168,74,0.35)] hover:shadow-[0_0_45px_rgba(212,168,74,0.55)] transition-all transform hover:-translate-y-0.5" data-id="element-216">
          💪 → QUIERO MI GUÍA AHORA
        </a>

        {/* Trust row */}
        <div className="mt-6 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-blue-100/80" data-id="element-217">
          <span className="flex items-center gap-1.5" data-id="element-218">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-1.5" data-id="element-219">🔒 Pago 100% seguro</span>
        </div>

        {/* Payment methods */}
        <div className="mt-2 text-sm text-blue-100/70" data-id="element-220">
          💳 Mercado Pago | Tarjeta | Transferencia
        </div>
      </motion.div>
    </section>;
}